/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcGenerateV1TradeConfirmationsJobEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_GENERATE_V1_TRADE_CONFIRMATIONS_JOB_EVENT_ENTITY_NAME = 'ixc.generate.v1.TradeConfirmationsJobEvent';
export const ixcGenerateV1TradeConfirmationsJobEventEntity = new schema.Entity<IxcGenerateV1TradeConfirmationsJobEvent>(IXC_GENERATE_V1_TRADE_CONFIRMATIONS_JOB_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcGenerateV1TradeConfirmationsJobEvent) => `${entity.metadata?.eventId}` });

